import { PopupType } from '../../../components/popup/types';
import type { CoreStoreType } from '../../../store/CoreStore';
import { gameStateActions } from '../../../store/slices/game/slice';
import { popupActions } from '../../../store/slices/popup/slice';
import type { IGameCommunicationProcessor, TableCloseMessage } from '../types';

export class GameCommunicationTableClosedProcessor implements IGameCommunicationProcessor {
  messageName = 'table_closed';

  process(message: TableCloseMessage, store: CoreStoreType): void {
    if (message?.openTime) {
      store.dispatch(gameStateActions.setTable({ openTime: message.openTime }));
    }
    store.dispatch(popupActions.overwritePopup(PopupType.TableClosed));
    store.dispatch(gameStateActions.setGamePaused(true));
  }
}
